import { segments, scale } from './svgPath';
interface Props { values: (number | null)[]; height?: number; width?: number | string; color?: string }
export default function Sparkline({ values, height = 28, width = 88 }: Props) {
  const runs = segments(values);
  const finite = runs.flat().map((p) => p.v);
  if (finite.length === 0) return <span className="text-muted">—</span>;
  const lo = Math.min(...finite), hi = Math.max(...finite);
  const x = scale(0, Math.max(1, values.length - 1), 3, 101);
  const y = scale(lo, hi === lo ? lo + 1 : hi, 25, 4);
  const last = runs[runs.length - 1][runs[runs.length - 1].length - 1];
  return (
    <svg width={width} height={height} viewBox="0 0 104 28" aria-hidden="true">
      {runs.map((run, k) => (
        <polyline key={k} fill="none" className="stroke-slate-ink" strokeWidth={2.2} strokeLinejoin="round" strokeLinecap="round"
          points={run.map((p) => `${x(p.i).toFixed(1)},${y(p.v).toFixed(1)}`).join(' ')} />
      ))}
      <circle cx={x(last.i)} cy={y(last.v)} r={3.5} className="fill-accent" />
    </svg>
  );
}
